import { Image, Button } from "@atoms";
import { AuthSection } from "@organisms";
import { useTranslation } from "react-i18next";

export interface UserAccountConfirmedPageTemplateProps {
  onSignInClick: () => void;
}

export const UserAccountConfirmedPageTemplate = ({
  onSignInClick,
}: UserAccountConfirmedPageTemplateProps): JSX.Element => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex">
      <AuthSection />

      {/* Right side - Confirmation message */}
      <div className="w-full lg:w-1/2 min-h-screen flex items-center justify-center bg-white">
        <div className="w-full max-w-md px-8 text-center">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            {t("auth.userConfirmed.title")}
          </h1>
          <p className="text-lg text-gray-700 mb-8">
            {t("auth.userConfirmed.description")}
          </p>
          {/* <Button
            variant="primary"
            label="Sign In"
            stretch
            color="neutral-darkest"
            hoverColor="neutral-dark"
            textColor="white"
            onClick={onSignInClick}
          /> */}
        </div>
      </div>
    </div>
  );
}; 
